import { useCallback, useMemo, useRef } from 'react';

import { Story } from '../../types';
import { getVideo } from '../../utils';

interface Props {
  story?: Story;
}

export const useVideo = ({ story }: Props) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  const video = useMemo(() => {
    if (story) return getVideo(story);
  }, [story]);

  const pauseVideo = useCallback(() => {
    videoRef.current?.pause();
  }, []);

  const playVideo = useCallback(async () => {
    try {
      await videoRef.current?.play();
    } catch (err) {
      pauseVideo();
      console.error(err);
    }
  }, [pauseVideo]);

  const resetVideo = useCallback(() => {
    if (videoRef.current) {
      videoRef.current.currentTime = 0;
    }
  }, []);

  const restartVideo = useCallback(() => {
    resetVideo();
    playVideo();
  }, [playVideo, resetVideo]);

  const stopVideo = useCallback(() => {
    pauseVideo();
    resetVideo();
  }, [pauseVideo, resetVideo]);

  return { video, videoRef, pauseVideo, playVideo, restartVideo, stopVideo };
};
